import { Component, Input } from "@angular/core";
import { AccountService } from "../../services/account.service";
import { WhoAmIVM } from "../../models";
import { BaseHtmlHelperComponent } from "../base/base.htmlhelper.component";
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from "@angular/router";

@Component({
  selector: 'account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent extends BaseHtmlHelperComponent {
  @Input() selectedMenu: number = 100;
  @Input() me: WhoAmIVM;
  messagesCount: number = 0;
  selectedTab: string = '';

  constructor(private router: Router, private accService: AccountService, private route: ActivatedRoute) {
    super();

    accService.getUnreadMessagesCount()
      .subscribe(returnValue => this.messagesCount = returnValue);

    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        console.log(val.url);
        this.emitDisplayLoadingDialog(true);
      }
      else if (val instanceof NavigationEnd) {
        console.log(val.url);
        this.emitDisplayLoadingDialog(false);
      }
    });

    route.url.subscribe(
      r => {
        this.selectedTab = r[0].path;
      }
    );
  }
}
